import DOMPurify from "dompurify";

/**
 * Sanitize HTML before injecting via dangerouslySetInnerHTML or element.innerHTML.
 * Uses a permissive HTML profile suitable for rich text (e.g. editor output).
 */
export function sanitizeHtml(dirty) {
  if (dirty == null || dirty === "") return "";
  return DOMPurify.sanitize(String(dirty), { USE_PROFILES: { html: true } });
}
